import { DATA_PAGINATION_COUNT } from '@/pages/allAnalytics/sections/postPerformance/helpers';
import axiosClient from '../../..//utils/axios';
import { resolve } from '../../../api/endPoints';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  locationUuid: '',
  cloudUuid: '',
  loadingData: false,
  postPerformanceData: [],
  oldPostPerformanceData: []
};

const postPerformanceSlice = createSlice({
  name: 'postPerformance',
  initialState,
  reducers: {
    updateEditorCloseState: (
      state,
      action: PayloadAction<{
        state: string;
      }>
    ) => {
      state.locationUuid = action.payload.state;
    },

    updateLoadingState: (state, action: PayloadAction<boolean>) => {
      state.loadingData = action.payload;
    },
    updateData: (state, action: PayloadAction<any[]>) => {
      state.postPerformanceData = action.payload;
    },
    updateOldData: (state, action: PayloadAction<any[]>) => {
      state.oldPostPerformanceData = action.payload;
    }
  }
});

export const { updateLoadingState, updateData, updateOldData } =
  postPerformanceSlice.actions;

export default postPerformanceSlice.reducer;

export const fetchPerfomanceData =
  ({
    locationSlug,
    onError,
    date_after,
    date_before
  }: {
    locationSlug: string;
    onError?: (err: any) => void;
    date_after: string;
    date_before: string;
  }) =>
  async (dispatch: any) => {
    dispatch(updateLoadingState(true));

    const baseParams = {
      analytics: 'True',
      has_been_published_on_platform: true,
      limit: DATA_PAGINATION_COUNT,
      offset: 0,
      location_slug: locationSlug,
      ordering: '-latest_upload_to_platform_timestamp',
      post_status: 4,
      format: 'json',
      publication_date_after: date_after,
      publication_date_before: date_before
    };

    let url = resolve('posts_analytics', {}, baseParams);
    let allResults: any[] = [];

    try {
      while (url) {
        console.log('Fetching:', url);
        const res = await axiosClient.get(url);
        const data = res?.data;

        if (data?.results) {
          allResults = [...allResults, ...data.results];
        }

        url = data?.next ?? null; // proceed to next page or stop
      }

      dispatch(updateData(allResults || []));
    } catch (error: any) {
      console.error('Error fetching post performance:', error);
      onError?.(error);
    } finally {
      dispatch(updateLoadingState(false));
    }
  };
